import React, { useContext, useEffect } from 'react';
import { Route, Navigate } from 'react-router-dom';
import AuthContext from './authContext';
import Messages from '../components/Messages';
// import { message } from 'antd';
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { currentUser, loading, logout } = useContext(AuthContext);
  const {showMessageOnce, messageHolder, showMessage, showMessageError} = Messages();
  // const user = Promise.resolve(currentUser) !== null ? Promise.resolve(currentUser) : null;
  // useEffect(() => {
  //   if (!loading && (!currentUser || !currentUser.id)) {
      
  //     console.log('User not authenticated.');
  //     // showMessageOnce('This is a test message', 'info');
  //     showMessageError('Bitte melden Sie sich erneut an.')

  //   }else {
  //     console.log('User authenticated.',currentUser);
  //   }
    
  // }, [currentUser, loading]);
  // TODO: Solve the issue of navigation ::: 
  if (loading) return null;
  return (
    <>
    
    {messageHolder}
    {/*TODO: Solve the issue of navigation {currentUser && currentUser.id ? (     */}
    {currentUser && currentUser.id ? (    
        <Component {...rest} />    
      ) : (
        <Navigate to="/" replace />
      
      )}
    </>
  );
};
export default ProtectedRoute;